export var cashflowTemplateData = [
    ['Code', 'Items', 'Department', 'Supplier', 'Customer', 'Amount', null, null],
    [null, 'INFLOW'],
    [null, 'I. Cash flow from business activities'],
    [],
    [],
    [],
    [null, 'II. Cash flow from investment activities'],
    [],
    [],
    [],
    [null, 'III. Cash flow from financial activities'],
    [],
    [],
    [],
    [null, 'OUTFLOW'],
    [null, 'I. Cash flow from business activities'],
    [],
    [],
    [],
    [null, 'II. Cash flow from investment activities'],
    [],
    [],
    [],
    [null, 'III. Cash flow from financial activities'],
    [],
    [],
    [],
    [null, 'NETFLOW']
];
export var CashflowTemplateStatus;
(function (CashflowTemplateStatus) {
    CashflowTemplateStatus["Published"] = "Published";
    CashflowTemplateStatus["Unpublished"] = "Unpublished";
})(CashflowTemplateStatus || (CashflowTemplateStatus = {}));
export var CashflowStatementStatus;
(function (CashflowStatementStatus) {
    CashflowStatementStatus["Merged"] = "Merged";
    CashflowStatementStatus["Approved"] = "Approved";
    CashflowStatementStatus["Requested"] = "Requested";
    CashflowStatementStatus["Declined"] = "Declined";
})(CashflowStatementStatus || (CashflowStatementStatus = {}));
